import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useParams } from 'react-router';

// UTILITY
import { getLink } from '@/utility/routes';

const Redirect = ({ to, external = false, replaceParams = false, ...props }) => {
  const params = useParams();
  let url = to;

  if (external) {
    window.location.href = url;
    return null;
  }

  if (replaceParams) {
    url = getLink(url, params);
  }

  return <Navigate {...props} to={url} replace />;
};

Redirect.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  external: PropTypes.bool,
  replaceParams: PropTypes.bool,
};

export default React.memo(Redirect);
